
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'ZRadioGroup',
  props: {
    modelValue: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    readOnly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      value: ''
    }
  },
  model: {
    prop: 'modelValue',
    event: 'change'
  },
  watch: {
    value(newValue) {
      if (!this.disabled && !this.readOnly) {
        this.$emit('change', newValue)
      }
    }
  }
})
